export const getRows = (events) => {
  if (!events || !Array.isArray(events)) {
    return [];
  }

  return events.map((event, index) => ({
    id: `${event.timestamp}-${event.user_email}-${index}`,
    timestamp: event.timestamp,
    user_email: event.user_email,
    event_message: event.event_message,
  }));
};
